import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getStoreForDropdown } from '../../../Redux/Action/StoreAction';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import Select from 'react-select';

function CommonStoreDropdown({ control, title = 'Choose Store', isRequired = false }) {
  const dispatch = useDispatch();
  const [myStores, setMyStores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const payload = {
      data: { search_key: '' },
      setMyStores,
      setIsLoading,
    };
    dispatch(getStoreForDropdown(payload));
  }, [dispatch]);

  return (
    <Form.Group
      className="mb-2"
      controlId="formBasicEmail"
    >
      <Form.Label>
        {title} {isRequired && <span className="text-danger">*</span>}
      </Form.Label>
      <Controller
        name="store_detail"
        control={control}
        rules={{
          required: isRequired ? `${title} is required` : false,
        }}
        render={({ field, fieldState: { error } }) => (
          <>
            <Select
              isLoading={isLoading}
              isClearable
              {...field}
              value={field?.value || null}
              options={myStores}
              getOptionLabel={(option) => `${option.store_name}`}
              getOptionValue={(option) => option.id}
            />
            {error && <small className="text-danger">{error.message}</small>}
          </>
        )}
      />
    </Form.Group>
  );
}

export default CommonStoreDropdown;
